import {
  createDraftSafeSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'

import { RootState } from '..'
import { NameSpace } from '../types'

interface TypeformState {
  closedIds: Array<string>
  closedMetaAdsIds?: Array<string>
  closedTikTokIds?: Array<string>
}

const initialState: TypeformState = {
  closedIds: [],
  closedMetaAdsIds: [],
  closedTikTokIds: [],
}

export const typeformProcess = createSlice({
  initialState,
  name: NameSpace.TYPEFORM,
  reducers: {
    setClosedTypeformList: (state, { payload }: PayloadAction<string[]>) => {
      state.closedIds = payload
    },
    setClosedTikTokTypeformList: (
      state,
      { payload }: PayloadAction<string[]>,
    ) => {
      state.closedTikTokIds = payload
    },
    setClosedMetaAdsTypeformList: (
      state,
      { payload }: PayloadAction<string>,
    ) => {
      if (!state.closedMetaAdsIds) {
        state.closedMetaAdsIds = []
      }
      if (!state.closedMetaAdsIds.includes(payload)) {
        state.closedMetaAdsIds.push(payload)
      }
    },
  },
})

export const {
  setClosedTypeformList,
  setClosedTikTokTypeformList,
  setClosedMetaAdsTypeformList,
} = typeformProcess.actions

const getState = (state: RootState): TypeformState => state.typeform

export const getClosedTypeformIds = createDraftSafeSelector(
  getState,
  ({ closedIds }) => closedIds,
)

export const getClosedTikTokTypeformIds = createDraftSafeSelector(
  getState,
  ({ closedTikTokIds }) => closedTikTokIds || [],
)

export const getClosedMetaAdsTypeformIds = createDraftSafeSelector(
  getState,
  ({ closedMetaAdsIds }) => closedMetaAdsIds,
)
